"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTheming = exports.ThemingContext = exports.ThemingConsumer = exports.Theming = void 0;

var _borderRadius = require("./borderRadius");

var _borderWidth = require("./borderWidth");

var _colors = require("./colors");

var _icons = require("./icons");

var _logo = require("./logo");

var _shape = require("./shape");

var _size = require("./size");

var _spacing = require("./spacing");

var _typography = require("./typography");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _modal = require("./modal");

var _sidesheet = require("./sidesheet");

var _popover = require("./popover");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// Theming Exports
var ThemingContext = /*#__PURE__*/_react["default"].createContext({
  BorderRadius: _borderRadius.borderRadiusAll,
  BorderWidth: _borderWidth.borderWidthAll,
  Colors: _colors.colorsAll,
  Icons: _icons.iconsDefaultValues,
  Logo: _logo.logoDefaultValues,
  Modal: _modal.modalDefaultValues,
  Popover: _popover.popoverDefaultValues,
  Shape: _shape.shapeAll,
  Sidesheet: _sidesheet.sidesheetDefaultValues,
  Size: _size.sizeAll,
  Spacing: _spacing.spacingAll,
  Typography: _typography.typographyDefaultValues
});

exports.ThemingContext = ThemingContext;

var Theming = function Theming(_ref) {
  var children = _ref.children,
      overrides = _ref.overrides;
  return /*#__PURE__*/_react["default"].createElement(ThemingContext.Provider, {
    value: {
      BorderRadius: overrides && (0, _borderRadius.themeBorderRadius)(overrides.BorderRadius),
      BorderWidth: overrides && (0, _borderWidth.themeBorderWidth)(overrides.BorderWidth),
      Colors: overrides && (0, _colors.themeColors)(overrides.Colors),
      Icons: overrides && (0, _icons.themeIcons)(overrides.Icons),
      Logo: overrides && (0, _logo.themeLogo)(overrides.Logo),
      Modal: overrides && (0, _utils.themeUpdate)(_modal.modalDefaultValues, overrides.Modal),
      Popover: overrides && (0, _utils.themeUpdate)(_popover.popoverDefaultValues, overrides.Popover),
      Shape: overrides && (0, _shape.themeShape)(overrides.Shape),
      Sidesheet: overrides && (0, _utils.themeUpdate)(_sidesheet.sidesheetDefaultValues, overrides.Sidesheet),
      Size: overrides && (0, _size.themeSize)(overrides.Size),
      Spacing: overrides && (0, _spacing.themeSpacing)(overrides.Spacing),
      Typography: overrides && (0, _typography.themeTypography)(overrides.Typography)
    }
  }, children);
};

exports.Theming = Theming;

var ThemingConsumer = function ThemingConsumer(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement(ThemingContext.Consumer, null, children);
};

exports.ThemingConsumer = ThemingConsumer;

var withTheming = function withTheming(Comp) {
  return /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    var theme = _react["default"].useContext(ThemingContext);

    return /*#__PURE__*/_react["default"].createElement(Comp, _extends({
      ref: ref,
      theme: theme
    }, props));
  });
};

exports.withTheming = withTheming;
ThemingConsumer.propTypes = {
  children: _propTypes["default"].func
};
Theming.propTypes = {
  children: _propTypes["default"].node,
  overrides: _propTypes["default"].object
};